import './styles/variables.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/components.css';
import './styles/views.css';
import './styles/responsive.css';
import './styles/animations.css';
import './styles/context.css';
import './styles/terminal.css';
import './styles/avi.css';

document.addEventListener('DOMContentLoaded', () => {
    initStandalone();
});

function initStandalone() {
    console.log('Standalone Page Initialized');
    
    // Set default dark theme if not specified
    const savedTheme = localStorage.getItem('theme') || 'dark';
    document.documentElement.classList.add(savedTheme);
    document.body.classList.add('standalone-page');

    // Initialize Hero Avi if present
    initHeroAvi();

    // Initialize Smilie Icons if present
    const smilies = document.querySelectorAll('.avi-smilie-icon');
    smilies.forEach(smilie => {
        // Basic animation or hover effects can be added here if needed
    });
}

function initHeroAvi() {
    const avi = document.querySelector('.hero-illustration');
    if (!avi) return;

    document.addEventListener('mousemove', (e) => {
        const eyes = document.querySelectorAll('.hero-avi-eye .pupil');
        eyes.forEach((pupil: any) => {
            const rect = pupil.parentElement.getBoundingClientRect();
            const eyeX = rect.left + rect.width / 2;
            const eyeY = rect.top + rect.height / 2;
            const angle = Math.atan2(e.clientY - eyeY, e.clientX - eyeX);
            const distance = Math.min(Math.hypot(e.clientX - eyeX, e.clientY - eyeY) / 10, 8);
            
            const x = Math.cos(angle) * distance;
            const y = Math.sin(angle) * distance;
            
            pupil.style.transform = `translate(${x}px, ${y}px)`;
        });
    });
}

// Global helpers for standalone pages
(window as any).showToast = (message: string) => {
    const toast = document.getElementById('toast');
    if (toast) {
        toast.textContent = message;
        toast.style.display = 'block';
        setTimeout(() => toast.style.display = 'none', 3000);
    } else {
        alert(message); // Fallback
    }
};

(window as any).handleSubscribe = async (btn: HTMLButtonElement) => {
    const input = btn.parentElement?.querySelector('input');
    const email = input?.value;
    if (!email || !email.includes('@')) {
        (window as any).showToast('Please enter a valid email.');
        return;
    }

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    try {
        const response = await fetch('https://formsubmit.co/ajax/gvtechhub@gmail.com', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ 
                email: email, 
                _subject: "New Newsletter Subscriber (Standalone Page)" 
            })
        });
        
        if (response.ok) {
            (window as any).showToast('Thank you for subscribing!');
            if (input) input.value = '';
        } else {
            throw new Error('Failed to subscribe');
        }
    } catch (err) {
        (window as any).showToast('Something went wrong. Please try again.');
    } finally {
        btn.disabled = false;
        btn.textContent = originalText;
    }
};

(window as any).comingSoon = (feature: string) => {
    alert(`${feature} is coming soon!`);
};

(window as any).showAuthOverlay = () => {
    window.location.href = '/?auth=true'; // Redirect to home with auth trigger
};

(window as any).showLandingHome = () => {
    window.location.href = '/';
};
